import React, { useEffect, useState } from 'react';
import provideScrollPosition from 'react-provide-scroll-position';
import ScrollTrigger from 'react-scroll-trigger';
import { Box } from 'rebass';
import styled from 'styled-components';
import Header from '../../../components/Header/Header';
import CardList from '../../../components_new/CardList';
import { Text, View, Whitespace } from '../../../components_new/common';
import DownloadAppModal from '../../../components_new/DownloadAppModal';
import Link from '../../../components_new/Link';
import collectImg from './../../../../images/banner/collect.jpg';
import banner2Img from './../../../../images/banner/experience-2-2.jpg';
import workBanner from './../../../../images/banner/work.jpg';
import HomeTopBanner from './HomeTopBanner';

const bannerHeight = 900;

const Home = (props) => {
  const { scrollTop, searchParams, loading } = props;

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // `useEffect` never runs on the server, so we must be on the client if we hit this block
    // which means looking for localStorage is safe
    const now = new Date().getTime();
    let timeModalLastViewed = localStorage.getItem('timeModalLastViewed');
    if (!timeModalLastViewed) {
      localStorage.setItem('timeModalLastViewed', now);
      timeModalLastViewed = now;
      setShowModal(true);
    }
    const millisecondsInaDay = 1000 * 60 * 60 * 24; // 86_400_000
    const days = 3;
    const daysAgo = now - millisecondsInaDay * days;
    if (timeModalLastViewed < daysAgo) {
      setShowModal(true);
      localStorage.setItem('timeModalLastViewed', now);
    }
  }, []);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <Box>
      {showModal && <DownloadAppModal isOpen={handleOpenModal} onRequestClose={handleCloseModal} />}
      <HomeTopBanner
        id="homeTopBanner"
        renderHeader={() => (
          <Header
            borderLess
            backgroundLess
            sticky
            isSearchVisible={scrollTop > 25}
            handleSearchChange={props.handleSearchChange}
            submit={props.submit}
            searchParams={searchParams}
            id="header"
          />
        )}
        handleSearchChange={props.handleSearchChange}
        handleCityChange={props.handleCityChange}
        searchParams={searchParams}
        submit={props.submit}
        height={bannerHeight + 'px'}
      />
      {
        //! getRecommendData. && !getImageBannerData.loading && !getMostViewedListingData.loading && //render component here
      }
      <Whitespace large />
      <Box style={{ overflowX: 'hidden', overflowY: 'hidden' }}>
        <Box ml={18}>
          <Text sectionheader mb={4} pl="34px">
            RECREATIONAL VEHICLES
            <Link to="/s?category=91">
              <Text link inline ml={4}>
                See all
              </Text>
            </Link>
          </Text>
          <CardList items={props.recreational || []} loading={loading} />
          <Whitespace large />
          <ScrollTrigger onEnter={() => props.loadMore(0)} />
          <Text sectionheader mb={4} pl="34px">
            OUTDOOR GEAR
            <Link to="/s?category=84">
              <Text link inline ml={4}>
                See all
              </Text>
            </Link>
          </Text>
          <CardList items={props.outdoor || []} loading={loading} />
          <Whitespace large />
          <Text sectionheader mb={4} pl="34px">
            ELECTRONICS
            <Link to="/s?category=85">
              <Text link inline ml={4}>
                See all
              </Text>
            </Link>
          </Text>
          <CardList items={props.electronics || []} loading={loading} />
        </Box>

        <Whitespace large />
        <SeparatorBlock2 src={banner2Img}>
          <ScrollTrigger onEnter={() => props.loadMore(1)} />
          <Text banner white bold letterSpacing="0.5px">
            / 'yoodl,iz /
          </Text>
          <Text white italic bannersmall pn light>
            verb.
          </Text>
          <Whitespace small />
          <Text bannersmall light white letterSpacing="0.5px">
            make practical and
          </Text>
          <Text bannersmall light white letterSpacing="0.5px">
            effective use of.
          </Text>
          <Whitespace small />
          <Text banner white bold letterSpacing="0.5px">
            What will you yoodlize?
          </Text>
          <Whitespace />
        </SeparatorBlock2>
        <Whitespace large />

        <Box ml={18}>
          <Text sectionheader mb={4} pl="34px">
            PARTY & WEDDING EQUIPMENT
            <Link to="/s?category=88">
              <Text link inline ml={4}>
                See all
              </Text>
            </Link>
          </Text>
          <CardList items={props.party || []} loading={loading} />

          <Whitespace large />

          <Text sectionheader mb={4} pl="34px" lineSpacing="-.4px">
            TOOLS
            <Link to="/s?category=86">
              <Text link inline ml={4}>
                See all
              </Text>
            </Link>
          </Text>
          <CardList items={props.tools || []} loading={loading} />
          <Whitespace large />

          <Text sectionheader mb={4} pl="34px">
            CLOTHING
            <Link to="/s?category=74">
              <Text link inline ml={4}>
                See all
              </Text>
            </Link>
          </Text>
          <CardList items={props.clothing || []} loading={loading} />

          <Whitespace large />
          <Text sectionheader mb={4} pl="34px">
            HOME & KITCHEN
            <Link to="/s?category=77">
              <Text link inline ml={4}>
                See all
              </Text>
            </Link>
          </Text>
          <CardList items={props.home || []} loading={loading} />
        </Box>

        <Whitespace large />
        <ScrollTrigger onEnter={() => props.loadMore(2)} />
        <SeparatorBlock3 src={workBanner} />
        <Whitespace large />

        <Box ml={18}>
          <Text sectionheader mb={4} pl="34px">
            TOYS & GAMES
            <Link to="/s?category=87">
              <Text link inline ml={4}>
                See all
              </Text>
            </Link>
          </Text>
          <CardList items={props.toys || []} loading={loading} />

          <Whitespace large />
          <Text sectionheader mb={4} pl="34px">
            LAWN & GARDEN
            <Link to="/s?category=93">
              <Text link inline ml={4}>
                See all
              </Text>
            </Link>
          </Text>
          <CardList items={props.garden || []} loading={loading} />

          <Whitespace large />
          <Text sectionheader mb={4} pl="34px">
            SPORTING GOODS
            <Link to="/s?category=76">
              <Text link inline ml={4}>
                See all
              </Text>
            </Link>
          </Text>
          <CardList items={props.sporting || []} loading={loading} />
          <Whitespace large />
          <Text sectionheader mb={4} pl="34px">
            DVDs & VIDEO GAMES
            <Link to="/s?category=97">
              <Text link inline ml={4}>
                See all
              </Text>
            </Link>
          </Text>
          {/* <CardList items={props.dvd || []} loading={loading} clickForModal={handleClickForModal} /> */}
        </Box>

        <Whitespace large />
        <ScrollTrigger onEnter={() => props.loadMore(3)} />
        <SeparatorBlock3 src={collectImg} />
        <Whitespace large />

        <Box ml={18}>
          <Text sectionheader mb={4} pl="34px">
            VENUES
            <Link to="/s?category=92">
              <Text link inline ml={4}>
                See all
              </Text>
            </Link>
          </Text>
          <CardList items={props.properties || []} loading={loading} />

          <Whitespace large />
          <Text sectionheader mb={4} pl="34px">
            MUSIC
            <Link to="/s?category=96">
              <Text link inline ml={4}>
                See all
              </Text>
            </Link>
          </Text>
          <CardList items={props.music || []} loading={loading} />
          <Whitespace large />

          <Text sectionheader mb={4} pl="34px">
            BUSINESS EQUIPMENT
            <Link to="/s?category=89">
              <Text link inline ml={4}>
                See all
              </Text>
            </Link>
          </Text>
          <CardList items={props.business || []} loading={loading} />
          <Whitespace large />

          <Text sectionheader mb={4} pl="34px">
            MISC
            <Link to="/s?category=95">
              <Text link inline ml={4}>
                See all
              </Text>
            </Link>
          </Text>
          <CardList items={props.misc || []} loading={loading} />
        </Box>
        <Whitespace xxlarge />
        <Box
          width="100%"
          style={{
            textAlign: 'center',
            margin: '0 auto',
            maxWidth: '1280px',
          }}
        >
          <Text primaryDark thin sectionbreakheaer style={{ textAlign: 'center' }}>
            Browse Categories
          </Text>
          <div className="g g-tc-fr-8 g-g-s px-l pt-m">
            {categories.map((c, i) => (
              <Card
                tile
                href={c.href}
                icon={c.icon}
                title={c.title}
                bottom={i < 8}
                idx={i}
                key={c.title}
              />
            ))}
          </div>
          <Whitespace xxlarge />
        </Box>
      </Box>
    </Box>
  );
};

//gray squares
function Card(props) {
  return (
    <Link to={props.href}>
      <div className={`h-125 p-s f f-rows f-start-center bg-offWhite`}>
        <View className="f-1 f-cc">
          <i className={props.icon + ' gray '} style={{ fontSize: '2.75em' }} />
        </View>
        <View className="f-center-start h-45">
          <Text noclip gray bold textAlign="center">
            {props.title.toUpperCase()}
          </Text>
        </View>
      </div>
    </Link>
  );
}

const SeparatorBlock2 = styled.div`
  background-image: ${(p) => `url('${p.src}');`}
  position: relative;
  height: 348px;
  background-size: cover;
  background-repeat: no-repeat;
  padding-left: 72px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
`;

const SeparatorBlock3 = styled.img`
  position: relative;
  width: 100%;
  height: auto;
  background-size: cover;
  background-repeat: no-repeat;
`;

export default provideScrollPosition(Home);

const categories = [
  {
    href: '/s?category=86',
    icon: 'fas fa-tools',
    title: 'Tools',
  },
  {
    href: '/s?category=84',
    icon: 'fas fa-campground',
    title: 'Outdoor Gear',
  },
  {
    href: '/s?category=85',
    icon: 'fas fa-camera-alt',
    title: 'Electronics',
  },
  {
    href: '/s?category=88',
    icon: 'fas fa-birthday-cake',
    title: 'Party & Wedding',
  },
  {
    href: '/s?category=91',
    icon: 'fas fa-motorcycle',
    title: 'Recreational Vehicles',
  },
  {
    href: '/s?category=74',
    icon: 'fas fa-tshirt',
    title: 'Clothing',
  },
  {
    href: '/s?category=77',
    icon: 'fas fa-home-heart',
    title: 'Home & Kitchen',
  },
  {
    href: '/s?category=87',
    icon: 'fas fa-dice',
    title: 'Toys & Games',
  },
  {
    href: '/s?category=93',
    icon: 'fas fa-flower-tulip',
    title: 'Lawn & Garden',
  },
  {
    href: '/s?category=76',
    icon: 'fas fa-skiing',
    title: 'Sporting Goods',
  },
  {
    href: '/s?category=97',
    icon: 'fas fa-compact-disc',
    title: 'DVDs & Video Games',
  },
  {
    href: '/s?category=92',
    icon: 'fas fa-archway',
    title: 'Venues',
  },
  {
    href: '/s?category=96',
    icon: 'fas fa-guitar',
    title: 'Music',
  },
  {
    href: '/s?category=95',
    icon: 'fas fa-alicorn',
    title: 'Misc',
  },
];



// WEBPACK FOOTER //
// ./src/routes/presentation/Home/Home.js